export default {
  home: {
    lang: 'EN',
    lang_cn: '繁體中文',
    lang_en: '英文',
    form_title: '【亞洲咖啡音樂節 x V23 首展 | 3月6 - 8日】',
    form_title2: '立即登記  獲取iCAUR V23最新資訊及優惠',
    form_title3: '參與創造潮改車',
    submit: '提交',
    mandatory: '必須填寫',
    yes: "是",
    no: "否",
    lastName: '姓氏',
    firstName: '名字 ',
    enterLastName: '請輸入姓氏 (姓名需與身份證相同)',
    enterFirstName: '請輸入名字 (姓名需與身份證相同)',
    emailAddress: '電郵',
    enterEmail: '請輸入電郵',
    rightEmail: '請輸入正確的郵箱！',
    contract: '訂車合同編號',
    rightContract: '請輸入訂車合同編號',
    mobileNumber: '手提電話',
    enterPhone: '請輸入電話號碼',
    rightPhone: '請輸入正確的電話！',
    privacyPolicy: '本人/我們同意錦龍、其聯屬公司、子公司及聯營公司根據收集個人資料聲明 及私隱政策聲明使用本人/我們的個人資料作直接營銷用途。',
    appellation: '稱謂',
    selectAppellation: '請選擇稱謂',
    corporateClient: '企業客戶',
    selectLanguage: '選擇語言',
    pleaseSelectLanguage: '請選擇語言',
    InformationSubmitted: '提交成功，謝謝!',
    submitted_: '您已預約成功',
    pleaseWriteName: '公司名稱',
    pleaseWriteName_: '如是，請提供公司名稱',
    agree_: '本人/我們已詳細閱讀並同意',
    rentCar_: '租車條款及細則',
    statement_: '收集個人資料聲明',
    policy_: '私隱政策聲明',
    and: ' 及 ',
    corporateClient_: '請選擇企業客戶',
    _policy: '必選',
    remark:'備註',
    fullStop:'。',
  },
  appellation: {
    Sir: '先生',
    lady: '女士',
    Miss: '小姐',
    professor: '教授',
  },
  carOption: {
    cartitle: '選擇車型',
    car1: 'V23 (RHD)',
    car2: 'V23 Sport (AWD)',
    carModel_:'請選擇車型',
  },
  dateTime: {
    dateTitle: '選擇日期',
    date_: '請選擇日期',
    timePeriodTitle: '選擇時段',
    timePeriod_: '請選擇時段'
  },
}

